import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
  en: {},
  es: {}
});

export default strings;
